import { useSearchParams } from 'react-router'
import { useAsync } from 'react-use'
import { getInviteContext, type InviteContext } from '../../api/auth'

export interface InviteContextState {
  inviteContext?: InviteContext
  loading: boolean
}

const useInviteContext = (): InviteContextState => {
  const [searchParams] = useSearchParams()
  const code = searchParams.get('state')

  const { value: inviteContext, loading } = useAsync(async () => (code ? getInviteContext(code) : undefined), [code])

  return { inviteContext, loading: !!code && loading }
}

export default useInviteContext
